'use strict';

var colors = {
    white: '#ffffff',
    turquoise100: '#5f9a8c',
    turquoise90: '#6ea397',
    turquoise80: '#7faea3',
    turquoise70: '#8eb8ae',
    turquoise60: '#9fc2ba',
    turquoise50: '#aeccc5',
    turquoise40: '#bfd7d1',
    turquoise30: '#cee0dc',
    turquoise20: '#dfebe8',
    turquoise10: '#eef4f3',
    red100: '#9c2232',
    red90: '#a53846',
    red80: '#b04e5b',
    red70: '#b9646f',
    red60: '#c47a84',
    red50: '#cd9098',
    red40: '#d7a7ad',
    red30: '#e1bcc1',
    red20: '#ebd3d6',
    red10: '#f5e8ea',
    charcoal100: '#323232',
    charcoal90: '#474747',
    charcoal80: '#5b5b5b',
    charcoal70: '#6f6f6f',
    charcoal60: '#848484',
    charcoal50: '#989898',
    charcoal40: '#adadad',
    charcoal30: '#c1c1c1',
    charcoal20: '#d6d6d6',
    charcoal20New: '#EBEBEB',
    charcoal10: '#eaeaea',
    ivorey: '#f9f8f6',
    charcoal3: '#f9f9f9',
    charcoal2: '#f9f9f8',
    yellow100: '#dca12f',
    yellow90: '#dfaa43',
    yellow80: '#e3b459',
    yellow70: '#e4bb6b',
    yellow60: '#eac782',
    yellow50: '#edcf96',
    yellow40: '#f1d9ac',
    yellow30: '#f4e2c0',
    yellow20: '#f8ecd5',
    yellow10: '#fbf5ea',
    green100: '#427B4A',
    green80: '#68966E',
    green50: '#A0BDA4',
    green30: '#DEE8DF',
    green10: '#EDF2ED',
    facebook01: '#4267B2',
    skeleton01: 'rgba(0,0,0,0.025)',
    skeleton02: 'rgba(0,0,0,0.3)',
    iconSuccess: '#427B4A',
    iconWarning: '#DCA12F',
    iconCritical: '#9C2232',
    borderSuccess: '#ABC1AE',
    borderWarning: '#E8D0A3',
    borderCritical: '#CE9EA4',
    borderTurquoise: '#DFEBE8',
    borderCharcoal: '#D6D6D6',
    surfaceSuccess: '#ECF2ED',
    surfaceWarning: '#FBF6EA',
    surfaceCritical: '#F5E9EA',
    surfaceTurquoise: '#EEF4F3',
    surfaceCharcoal: '#F9F9F9',
    flagsGreen: '#3B8C46',
    flagsYellow: '#EEBB00',
    flagsRed: '#BB2233',
    flagsBlue: '#006699',
    clubBarBannerGradientStart: '#E0AF91',
    clubBarBannerGradientEnd: '#E7A96A',
    component: {
        get productTileSurface() {
            return '#F9F8F6';
        },
    },
};

exports.colors = colors;
//# sourceMappingURL=colors-8c38b626.js.map
